<template>
<div class="student-auth">
    <div class="student_auth_block">
        <div class="header">
            <img class="icon-box" src="//file.40017.cn/appresource/image/forStudent/new/cer_look@3x.png" />
            <p class="txt-box">暂仅支持16-26岁普通高等学校在读学生认证</p>
        </div>
        <section class="info-box">
            <h4 class="title-box">基础信息</h4>
        
            <div class="write_item">
                <div class="item_ttl">
                    <span>姓名</span>
                </div>
                <div class="r">
                <input
                    :onfocus="isEdit"
                    @blur.prevent="changeCount()"
                    v-model="userName.value"
                    placeholder="请填写姓名"
                    type="text"
                />
                </div>
                <div class="input_warn" v-if="userName.showWarning">
                    {{ userName.warning }}
                </div>
                <div class="no-me-box" @click="skip()">
                    <van-icon name="//file.40017.cn/appresource/image/forStudent/new/cer_edit@3x.png" size="22" class="tip-icon" />
                    <div class="label">编辑</div>
                </div>
            </div>
            <div class="write_item">
                <p class="item_ttl">身份证</p>
                <div class="r">
                    <input
                        :onfocus="isEdit"
                        @blur.prevent="changeCount()"
                        v-model="IDCard.value"
                        maxlength="18"
                        placeholder="请填写身份证号码"
                        type="text"
                    />
                </div>
                <div class="input_warn" v-if="IDCard.showWarning">
                    {{ IDCard.warning }}
                </div>
            </div>
            <div class="input_warn-long" v-if="isFitAge">* 很遗憾您的年龄不在16-23岁，无法认证成为同程学生！</div>
            <div class="write_item">
                <p class="item_ttl">学校</p>
                <div class="r r-school" @click="jumps">
                    <input
                        class="rs"
                        onfocus="this.blur();"
                        @blur.prevent="changeCount()"
                        v-model="school.value"
                        placeholder="请选择学校"
                        type="text"
                        maxlength="50"
                    />
                </div>
                <div class="input_warn" v-if="school.showWarning">
                    {{ school.warning }}
                </div>
                <div class="r-btn" @click="jumps"></div>
            </div>
            <div class="write_item">
                <p class="item_ttl">手机号</p>
                <div class="r">
                    <input
                        @blur.prevent="changeCount()"
                        v-model="userPhone.value"
                        placeholder="请输入手机号"
                        type="tel"
                        maxlength="11"
                    />
                </div>
                <div class="input_warn"  v-if="userPhone.showWarning">
                    {{ userPhone.warning }}
                </div>
            </div>
            <div class="write_item">
                <p class="item_ttl">验证码</p>
                <div class="r">
                    <input
                        @blur.prevent="changeCount()"
                        v-model="verifyCode.value"
                        class="input_verify_code"
                        placeholder="请填写验证码"
                        maxlength="4"
                        type="text"
                    />
                </div>
                <div class="input_warn" v-if="verifyCode.showWarning">
                    {{ verifyCode.warning }}
                </div>
                <p
                class="send_verify_code"
                :class="{
                    invalid: !(
                    verifyCodeTxt == '发送验证码' && userPhone.value.length == 11
                    ),
                }"
                @click="sendVerifyCode"
                >
                {{ verifyCodeTxt }}
                </p>
            </div>
        </section>
        <!-- 上传学生证 -->
        <section class="info-box">
            <h4 class="title-box">在校证明信息</h4>
            <div class="upload_block">
                <div class="sub_title">
                    请上传学生证封面和内页信息，或录取通知书正反面
                </div>
                <div class="sub_img">
                    <div class="sub_item">
                        <div class="empty" v-if="!list[0].idCardImgUrl"  @click="selectPhoto(0)">
                            <img class="upload-img"
                                src="https://file.40017.cn/appresource/image/forStudent/new/cer_camer@3x.png"
                            />
                            <div :class="['tip-upload',{ warn: list[0].showWarning }]">上传在校证明照片</div>
                        </div>
                        <div class="card_wrap" v-if="list[0].idCardImgUrl">
                            <img :src="list[0].idCardImgUrl" class="card_img" />
                        </div>
                        <div class="close_btn" @click="delCard(0)" v-if="list[0].idCardImgUrl">
                            ×
                        </div>
                    </div>
                    <div class="sub_item">
                        <div class="empty" v-if="!list[1].idCardImgUrl" @click="selectPhoto(1)">
                            <img class="upload-img"
                                src="https://file.40017.cn/appresource/image/forStudent/new/cer_camer@3x.png" 
                            />
                            <div :class="['tip-upload', { warn: list[1].showWarning }]">上传在校证明照片</div>
                        </div>
                        <div class="card_wrap" v-if="list[1].idCardImgUrl">
                        <img :src="list[1].idCardImgUrl" class="card_img" />
                        </div>
                        <div
                        class="close_btn"
                        @click="delCard(1)"
                        v-if="list[1].idCardImgUrl"
                        >×</div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <!-- 点击认证 -->
    <div class="authentication" :style="{'top': topStyle.top}">
      <div :class="['student-btn', {'disable': hasEmpty}]" @click="startAuth">提交认证信息</div>
      <div class="agreement">
        <van-icon class="icon-box" size="15" :name="isAgreed ? 'https://file.40017.cn/appresource/image/forStudent/new/cer_checked@3x.png': 'circle'" :color=" isAgreed ? '#5EC5FF' : '#ddd'" @click="isAgreed = !isAgreed" />
        我已经阅读并同意<span
          :style="{ color: '#06C584' }"
          @click="toRule"
          >《学生资格校验协议》</span
        >
      </div>
    </div>
    <!-- 认证状态弹窗 -->
    <van-popup
        v-model="showStatus"
        round
        :close-on-click-overlay="false"
        class="popup-status-box"
    >
        <img :src="statusInfo[statusType].img" alt="" class="status-icon">
        <div class="cont-status">
            <div class="result">{{statusInfo[statusType].state}}</div>
            <div class="reason" v-html="statusInfo[statusType].reason"></div>
            <div class="btn" @click="statusClick">{{statusInfo[statusType].btnTxt}}</div>
        </div>
    </van-popup>
    
    <!-- 离开确认弹窗 -->
    <van-popup
        v-model="showLeave"
        class="popup-leave-box"
    >
        <h4 class="title-box">确认退出身份认证吗？</h4>
        <p class="text">退出后，您可能会错过以下权益</p>
        <div class="cont-list">
            <div class="item-box" v-for="(item,index) in baseRight" :key="index">
                <img class="img-box" :src="item.icon" alt="">
                <div class="txt-box">
                    <h4 class="tit">{{item.title}}</h4>
                    <p class="desc">{{ item.subTitle }}</p>
                </div>
            </div>
        </div>
        <div class="btn-box">
            <div class="btn" @click="okLeave">仍要退出</div>
            <p class="line"></p>
            <div class="btn" @click="cancelLeave">继续认证</div>
      </div>
    </van-popup>

    <!-- 实名确认弹窗 -->
    <van-popup
        v-model="confirmRealName"
        :close-on-click-overlay="false"
        class="popup-leave-box"
    >
         <p class="text long-txt">请使用身份证实名认证后进行学生认证</p>
        <div class="btn-box">
            <div class="btn" @click="cancel">取消</div>
            <div class="btn" @click="toCertification">去认证</div>
      </div>
    </van-popup>
</div>
</template>
<script>
import { submitAuth, getAuthData, sendVerifyCodeApi } from "@/api/studentCertification/certification"
import { Popup, Icon, Dialog, Toast  } from 'vant';
import { toPage, compareVersion } from "@/utils/tools";
import request from '@/utils/request'

//事件埋点
const setEvent = (eventInfo) => {
  const { category = 'cvg2021_apppublic_students_certification', action = '', label = '', value = '', pagename = 'TAPP学生专区' } = eventInfo
  console.log('事件埋点', eventInfo)
  window._tc_bridge_util.set_category_event({
    "param": {
      category,
      action,
      optLabel: label,
      optValue: typeof value === 'object' ? JSON.stringify(value) : value,
      pagename
    }
  })
}

export default {
    name: "StudentAuth",
    components: {
        [Popup.name]: Popup,
        [Icon.name]: Icon
    },
    computed: {
        hasEmpty() {
            if (this.userName.value && this.IDCard.value && this.userPhone.value && this.school.value && this.verifyCode.value && this.list[0].idCardImgUrl && this.list[1].idCardImgUrl) {
                return false
            } else {
                return true
            }
        },
    },
    data() {
        return {
            deviceInfo: {},
            loginInfo: {},
            showRule: false,
            showStatus: false,
            isFitAge: false,
            showLeave: false,
            statusType: 1, // 认证状态 0：成功； 1：失败； 2：认证中
            confirmRealName: false,
            baseRight: [
                // {
                //     icon: 'https://file.40017.cn/appresource/image/forStudent/new/bg_header@2x.png',
                //     greyIcon: 'https://file.40017.cn/appresource/image/forStudent/new/img_close@2x.png',
                //     type: '1',
                //     title: '机火单单返现',
                //     subTitle: '最高返40元'
                // },{
                //     icon: 'https://file.40017.cn/appresource/image/forStudent/new/bg_header@2x.png',
                //     greyIcon: 'https://file.40017.cn/appresource/image/forStudent/new/img_close@2x.png',
                //     type: '2',
                //     title: '千元出行学生卡',
                //     subTitle: '最高返40元'
                // }
            ],
            statusInfo: [ 
                {
                    type: 1, // success
                    class: 'success',
                    img: '//file.40017.cn/appresource/image/forStudent/new/cer_success@3x.png',
                    state: '身份认证成功',
                    reason: '恭喜您认证成功，快领取您的专属特权吧',
                    btnTxt: '去领特权'
                },
                {
                    type: 2, // failed
                    class: 'failed',
                    img: '//file.40017.cn/appresource/image/forStudent/new/cer_fail@3x.png',
                    state: '身份认证失败',
                    // reason: '认条件不符合，请您检查<span class="tip">身份证</span>和<span class="tip">学校</span>之后可再提交',
                    reason: '啊哦，认证失败啦',
                    btnTxt: '知道了'
                },
                 {
                    type: 3, // 认证中
                    class: 'authing',
                    img: '//file.40017.cn/appresource/image/forStudent/success@3x.png',
                    state: '',
                    reason: '预计需等待  15秒',
                    btnTxt: '认证中...'
                }
            ],
            isAgreed: false,
            photos : [],
            picUploadList: [],
            jumpRealName: false, // 跳转实名
            // 兼容输入法样式
            selectStyle:{
                top:""
            },
            // 兼容输入法
            topStyle:{
                top:''
            },
            isEdit:'',//是否可编辑
            isStats:false,//显示学历弹框
            isBox:false, //显示弹窗
            schoolData:[],// 学校数据
            schoollist:[],// 搜索数据
            schoolname:'',// 学校名称
            selectindex:'-1', //选中位置
            clientHeight:"", //视窗大小
            btnstate:true, //确定按钮状态
            userName: {
                value: '',
                showWarning: false,
                warning: '',
            },
            IDCard: {
                value: '', //110101200005287252
                showWarning: false,
                warning: '',
            },
            userPhone: {
                value: '',
                showWarning: false,
                warning: '',
            },
            school: {
                value: '',
                showWarning: false,
                warning: '',
            },
            verifyCode: {
                value: '',
                showWarning: false,
                warning: '',
            },
            verifyCodeTxt: '发送验证码',
            list: [
                {
                    // idCardImgUrl: "data:image/jpeg;base64,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",
                    // keyId: "http://pic5.40017.cn/i/ori/10InNnWlaVO.png",
                    idCardImgUrl: '',
                    keyId: '',
                    showWarning: false,
                },
                {
                    idCardImgUrl: '',
                    showWarning: false,
                    keyId: '',
                },
            ],
        }
    },
    watch: {
        'userName.value'() {
            if (this.userName.showWarning) {
                this.checkUserName()
            }
        },
        'IDCard.value'() {
            if (this.IDCard.showWarning || this.isFitAge) {
                this.checkIDCard()
            }
        },
        'userPhone.value'() {
            if (this.userPhone.showWarning) {
                this.checkUserPhone()
            }
        },
        'school.value'() {
            if (this.school.showWarning) {
                this.checkSchool()
            }
        },
        'verifyCode.value'() {
            if (this.verifyCode.showWarning) {
                this.checkVerifyCode()
            }
        },
    },
    created() {
        // this.getschool()
        _multi_bridge_ready(() => {
            window._tc_bridge_bar?.set_navbar({
                param: {
                    left: [{ tagname: "tag_click_back" }],
                    center: [{ tagname: 'tag_title', value: '身份认证' }],
                },
                callback: (data)=> {
                    if (data.tagname == "tag_click_back" && this.statusType !== 0) {
                        this.showLeave = true
                        setEvent({
                            action: 'attest_detain_show',
                            label: '学生认证挽留弹窗曝光',
                            value: ''
                        })
                    } else if (data.tagname == "tag_click_back") {
                        _tc_bridge_util.set_webview_back()
                    }
                },
            })
            window._tc_bridge_user?.get_device_info({
                param: {},
                callback: (data)=> {
                    const dbody = JSON.parse(data.CBData);
                    const deviceInfo = dbody.deviceInfo;
                    this.deviceInfo = dbody.deviceInfo;
                    console.log('设备信息', this.deviceInfo);
                    // if (window._tc_bridge_public.platform == 1) {
                        //安卓
                        // that.statusHei = deviceInfo.statusBarHeightPx / 3;
                    // } else {
                        // that.statusHei = deviceInfo.statusBarHeightPx;
                    // }
                    window._tc_bridge_user.user_login({
                        callback: (res) => {
                            const data = JSON.parse(res.CBData);
                            this.loginInfo = data.memberInfo
                            const userKey = data.memberInfo.memberId
                            const nickName = data.memberInfo.nickName
                            console.log('1111登录信息111111111', this.loginInfo);
                            if (userKey) {
                                this.getAuthenticationData()
                                this.getHomeInfo()
                            } else {
                                window._tc_bridge_util.set_webview_back()
                            }
                        }
                    })
                }
            });
            let isFirst = true
            // webapp 激活，失活通知
            if (window._tc_bridge_public?.isTc) {
                let that = this
                window._tc_web_bar = {
                    //头部
                    tag_isStop: data => {
                        if (!isFirst) {
                            if (data.isStop == 'true' || data.isStop === true) {
                                //失活
                            } else {
                                //激活..
                                that.getAuthenticationData()
                            }
                        }
                        isFirst = false
                    },
                }
            }
        })
    },
    mounted(){
        // this.category=window._tc_bridge_public.isTc? 'APP学生' : '微信学生'
        this.channelcode=this.$route.query.channelcode
        this.moduleActGuid=this.$route.query.moduleActGuid
        this.clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        var btnTop=document.querySelector('.authentication').offsetHeight
        this.topStyle.top = (this.clientHeight-btnTop-30)+'px'
        console.log('高度高度高度高度高度',this.topStyle.top);
    },
    methods: {
        getHomeInfo() {
            request({
                url: `${process.env.VUE_APP_BASE_URL}/backendActivity/student/index`,
                method: 'post',
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    platTag: 'tcapp',
                    secureToken: this.loginInfo.memberIdNew,
                    deviceId: this.deviceInfo.deviceId
                },
                data: {}
            }).then((res) => {
                if (+(res?.code) === 0 && res.data) {
                    const tempArr = res.data.authRight || []
                    // 过滤出基础权益
                    this.baseRight = tempArr.filter(item => +item.type === 1).slice(0, 2)
                }
                // console.log('homeData---', this.authRight);
            }).catch((err) => {
                
            })
        },
        skip(){ // 这不是我点击跳转实名页面
            this.jumpRealName = true
            setEvent({
                action: 'toast_click',
                label: '姓名提示点击',
                value: ''
            })
            if (compareVersion(this.deviceInfo.appVersionNumber,'10.4.3') > -1) {
                toPage('https://m.17u.cn/certification/tcRealName?wvc3=1&tcwvclogin')
            } else {
                window.location.href = window._tc_bridge_public.isTc? 'tctclient://member/realNameAuth' : ''
            }
        },
        // 跳转到规则
        toRule(){
            // this.$router.push({path: '/studentAuthAgreement', query:{  }})
            toPage(`/studentAuthAgreement`)
        },
        // 上滑加载事件
        toploade(value){
            document.querySelector('.select').onscroll = ()=>{
                var  scrollH = document.querySelector('.select').offsetHeight
                var  scrollT = document.querySelector('.select').scrollTop
                // console.log(scrollT);
                this.num = this.num || 100
                if((scrollH*(this.num/10-1)+this.num*16)-scrollT<10){
                this.num+=100
                this.schoollist=value.slice(0,this.num)
                }
            }
        },
        jumps(){ 
            console.log('11111click2222');
            // this.$router.push({path: '/schoolList'})
            toPage(`/schoolList`, (data)=> {
                this.school.value = JSON.parse(data.CBData).result
            })

        },
        // 获取实名认证数据
        getAuthenticationData(){
            this.$loading.show({ type: 'part' });
            let paramsData = {
                headers: {
                    platTag: 'tcapp',
                    secureToken: this.loginInfo.memberIdNew,
                    deviceId: this.deviceInfo.deviceId
                },
                params: {}
            }
            getAuthData(paramsData).then(res => {
                console.log('实名认证信息', res);
                if (+(res?.code) === 0 && +res.data.isVerify === 1) {
                    this.isEdit='this.blur();'
                    this.userName.value = res.data.name || ''
                    this.IDCard.value = res.data.idNumber || ''
                } else {
                    // this.isEdit=''
                    // this.userName.value = ''
                    // this.IDCard.value =''
                    console.log('无实名认证');
                    this.confirmRealName = true
                    setEvent({
                        action: 'realname_detain_show',
                        label: '实名弹窗曝光',
                        value: ''
                    })
                }
                setEvent({
                    action: 'students_certification_pageshow',
                    label: '学生认证页面曝光',
                    value: {"channel":"学生认证","scene":"公共","realname": +res.data.isVerify === 1 ? '是' : '否',"refid": this.$route.query.refid}
                })
                this.$loading.hide()
            }).catch(()=> {
                this.$loading.hide()
            })
        },
        //失去焦点页面恢复
        changeCount() {
            setTimeout(() => {
                scrollTo(0, pageYOffset + 1)
            }, 0)
        },
        //发送验证码
        sendVerifyCode() {
            if (this.checkUserPhone()) {
                return
            }
            if (this.verifyCodeTxt != '发送验证码') return
            const done = ()=> {
                // 滑块认证
                this.$showVerify((response, type) => {
                    // console.log(1111, response, type)
                    let paramsData = {
                        headers: {
                            platTag: 'tcapp',
                            secureToken: this.loginInfo.memberIdNew,
                            deviceId: this.deviceInfo.deviceId
                        },
                        params: {
                            mobile: this.userPhone.value,
                            projectId: 'tcwireless_net_activityplatform',
                            response: response,
                            type: type
                        }
                    }
                    sendVerifyCodeApi(paramsData).then(res => {
                        if (+(res?.code) === 0 && res.data) {
                            let cont = 60
                            this.verifyCodeTxt = cont + 's可重发'
                            let timer = setInterval(() => {
                                cont--
                                this.verifyCodeTxt = cont + 's可重发'
                                if (cont <= 0) {
                                clearInterval(timer)
                                this.verifyCodeTxt = '发送验证码'
                            }
                            }, 1000)
                            Toast('验证码已发送，请关注短信')
                        } else {
                            Toast('验证码发送失败')
                        }
                    })
                })
            }
            this.$util.debounce(done, 300)(); 
        },
        selectPhoto(type) {
            if (!window._tc_bridge_public.isAppVersionGreatThan(1001)) {
                this.$dialog.show({
                    title: '检查更新',
                    message: '您当前版本较低，暂不支持上传照片',
                    showCancel: true,
                    cancelText: '暂不升级',
                    confirmText: '立即升级'
                }).then(() => {
                    location.href = "eltclient://app/upgrade?showLoading=1"
                })
                .catch(() => {
                    // on cancel
                });
            }
            if (this.photos.length >= 5) {
                return Toast("最多只能上传1张照片哦~")
            }
            window._tc_bridge_util.upload_photo({
                param: {
                    imgCount: '1',
                    uploadType: '1',
                },
                callback: (data) => {
                    // return console.log(data)
                    const imgs = JSON.parse(data.CBData).imageList || []
                    if (imgs.length > 0) {
                        // let imgb64 = []
                        this.list[type].keyId = imgs[0].imageServerPath
                        this.list[type].idCardImgUrl = imgs[0].imageServerPath
                        // for (let item of imgs) {
                        //     const b64str = "data:image/png;base64," + item.imageBase64
                        //     imgb64.push(b64str)
                        //     this.picUploadList.push({ imgStream: b64str.replace(/^.*?,/, "") })
                        // }
                        // this.photos = this.photos.concat(imgb64);
                    }
                },
            });
        },
        // 通过base64获取上传图片获取url
        uploadPhoto(imageBase64) {

            return new Promise((resolve, reject) => {
                if (this.picUploadList.length > 0) {
                    window._tc_bridge_util.get_data({
                        param: {
                            servicename: "imageupload",
                            requrl:
                            "https://tcmobileapi.17usoft.com/common/general/imageuploadhandler.ashx",
                            reqbody: {
                                picUploadList: this.picUploadList,
                                uploadType: "1",
                                upToServer: "1",
                            },
                        },
                        callback: (res) => {
                            const data = JSON.parse(res.CBData).response;
                            const header = data.header,
                            dbody = data.body || {};
                            if (header.rspCode == "0000") {
                                let imag = [];
                                for (let item of dbody.uploadImageList) {
                                    imag.push(item.imgUrl);
                                }
                                console.log('imgimgimgimigm', imag);
                                //如果重新编辑且有图片
                                if (this.picUploadList.length > 0) {
                                    imag.concat(this.picUploadList);
                                }
                                resolve(imag);
                            } else {
                                //未认证
                                reject(header.rspDesc);
                            }
                        },
                    });
                } else {
                    resolve(this.picUploadList);
                }
            });


        },
        //删除图片
        delCard(i) {
            this.list[i].keyId = ''
            this.list[i].idCardImgUrl = ''
        },
        //年龄计算
        GetAge(cardid) {
            let identityCard = cardid.toString()
            let len = (identityCard + '').length
            let strBirthday = ''
            if (len == 18) {
                //处理18位的身份证号码从号码中得到生日和性别代码
                strBirthday =
                identityCard.substr(6, 4) +
                '/' +
                identityCard.substr(10, 2) +
                '/' +
                identityCard.substr(12, 2)
            }
            if (len == 15) {
                let birthdayValue = ''
                birthdayValue = identityCard.charAt(6) + identityCard.charAt(7)
                if (parseInt(birthdayValue) < 10) {
                strBirthday =
                    '20' +
                    identityCard.substr(6, 2) +
                    '/' +
                    identityCard.substr(8, 2) +
                    '/' +
                    identityCard.substr(10, 2)
                } else {
                strBirthday =
                    '19' +
                    identityCard.substr(6, 2) +
                    '/' +
                    identityCard.substr(8, 2) +
                    '/' +
                    identityCard.substr(10, 2)
                }
            }
            //时间字符串里，必须是“/”
            let birthDate = new Date(strBirthday)
            let nowDateTime = new Date()
            let age = nowDateTime.getFullYear() - birthDate.getFullYear()
            //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
            if (
                nowDateTime.getMonth() < birthDate.getMonth() ||
                (nowDateTime.getMonth() == birthDate.getMonth() &&
                nowDateTime.getDate() < birthDate.getDate())
            ) {
                age--
            }
            return age
        },
        //身份证验证
        cidInfo(sId) {
            let tj = true
            let aCity = {
                11: '北京',
                12: '天津',
                13: '河北',
                14: '山西',
                15: '内蒙古',
                21: '辽宁',
                22: '吉林',
                23: '黑龙江',
                31: '上海',
                32: '江苏',
                33: '浙江',
                34: '安徽',
                35: '福建',
                36: '江西',
                37: '山东',
                41: '河南',
                42: '湖北',
                43: '湖南',
                44: '广东',
                45: '广西',
                46: '海南',
                50: '重庆',
                51: '四川',
                52: '贵州',
                53: '云南',
                54: '西藏',
                61: '陕西',
                62: '甘肃',
                63: '青海',
                64: '宁夏',
                65: '新疆',
                71: '台湾',
                81: '香港',
                82: '澳门',
                91: '国外',
            }
            let iSum = 0
            let info = ''
            if (!/^\d{17}(\d|x)$/i.test(sId)) {
                tj = false
            }
            sId = sId.replace(/x$/i, 'a')
            if (aCity[parseInt(sId.substr(0, 2))] == null) {
                tj = false
            }
            let sBirthday =
                sId.substr(6, 4) +
                '-' +
                Number(sId.substr(10, 2)) +
                '-' +
                Number(sId.substr(12, 2))
            let d = new Date(sBirthday.replace(/-/g, '/'))
            if (
                sBirthday !=
                d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
            ) {
                tj = false
            }
            for (let i = 17; i >= 0; i--) {
                iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11)
            }
            if (iSum % 11 != 1) {
                tj = false
            }
            return tj
        },
        checkInput() {
            let flag = false

            if (this.checkUserName()) {
                flag = true
            }
            if (this.checkIDCard()) {
                flag = true
            }
            if (this.checkUserPhone()) {
                flag = true
            }
            if (this.checkSchool()) {
                flag = true
            }
            if (this.checkVerifyCode()) {
                flag = true
            }
            if (this.checkUploadPic()) {
                flag = true
            }
            return flag
        },
        checkUserName() {
            let flag = false
            if (this.userName.value == '') {
                // this.userName.showWarning = true
                // this.userName.warning = '请输入姓名'
                Toast('请输入姓名')
                flag = true
            } else {
                this.userName.showWarning = false
            }
            return flag
        },
        checkIDCard() {
            if (this.isEdit) {
                return
            }
            let flag = false
            this.IDCard.showWarning = false
            this.isFitAge = false
            let v = this.IDCard.value
            if ((v.length != 18 && v.length != 15) || !this.cidInfo(v)) {
                // this.IDCard.showWarning = true
                // this.IDCard.warning = '请输入正确的身份证号码'
                Toast('请输入正确的身份证号码')
                flag = true
            } else if (this.GetAge(v) > 26 || this.GetAge(v) < 16) {
                    this.isFitAge = true
                    // this.IDCard.warning = '* 很遗憾您的年龄不在16-23岁，无法认证成为同程学生！'
                    flag = true
            } else {
                // console.log('333333333333');
                this.IDCard.showWarning = false
                this.isFitAge = false
            }
            return flag
        },
        checkUserPhone() {
            let flag = false
            if (!/^1\d{10}$/.test(this.userPhone.value)) {
                // this.userPhone.showWarning = true
                // this.userPhone.warning = '请输入正确的手机号码'
                Toast('请输入正确的手机号码')
                flag = true
            } else {
                this.userPhone.showWarning = false
            }
            return flag
        },
        checkSchool() {
            let flag = false
            if (this.school.value.length < 2) {
                // this.school.showWarning = true
                // this.school.warning = '请输入正确的学校名称'
                Toast('请输入正确的学校名称')
                flag = true
            } else {
                this.school.showWarning = false
            }
            return flag
        },
        checkVerifyCode() {
            let flag = false
            if (this.verifyCode.value.length != 4) {
                // this.verifyCode.showWarning = true
                // this.verifyCode.warning = '请输入正确的验证码'
                Toast('请输入正确的验证码')
                flag = true
            } else {
                this.verifyCode.showWarning = false
            }
            return flag
        },
        checkUploadPic() {
            let flag = false
            if (
                this.list[0].keyId == '' || this.list[1].keyId == ''
            ) {
                flag = true
                if (this.list[0].keyId == '') {
                // this.list[0].showWarning = true
                Toast('请上传在校证明照片')
                }
                if (this.list[1].keyId == '') {
                // this.list[1].showWarning = true
                Toast('请上传在校证明照片')
                }
            }
            return flag
        },
        // <-- check input
        startAuth() {
            setEvent({
                action: 'submit_click',
                label: '提交认证点击',
                value: ''
            })
            if (!this.isAgreed) {
                Toast('请先勾选同意后再提交认证')
                return
            }
            if (this.checkInput()) {
                return
            }
            setEvent({
                action: 'attest_show',
                label: '认证中弹窗曝光',
                value: ''
            })
            this.$loading.show({ type: 'part', text: '身份认证中' });
            let paramsData = {
                headers: {
                    platTag: 'tcapp',
                    secureToken: this.loginInfo.memberIdNew,
                    deviceId: this.deviceInfo.deviceId
                },
                params: {
                    name: this.userName.value,
                    cardId: this.IDCard.value,
                    phone: this.userPhone.value,
                    code: this.verifyCode.value,
                    school: this.school.value || undefined, // 认证时所读学校
                    images: [this.list[0].keyId, this.list[1].keyId],
                }
            }
            submitAuth(paramsData).then(res => {
                this.$loading.hide()
                console.log('认证结果', res)
                if (+(res?.code) === 0) {
                    switch (+res.data) {
                        case 0:
                            this.statusType = 0
                            // this.showStatus = true
                            this.statusInfo[0].reason = `恭喜您认证成功啦，快去领取权益吧`
                            break
                        case 3005:
                            this.statusType = 1
                            // this.showStatus = true
                            this.statusInfo[1].reason = `您已认证过咯，请勿重复认证`
                            break
                        case 3104:
                            this.statusType = 1
                            // this.showStatus = true
                            this.statusInfo[1].reason = `您已不符合年龄要求，去看看其他活动吧`
                            break
                        case 3101:
                            this.statusType = 1
                            // this.showStatus = true
                            this.statusInfo[1].reason = `公安接口身份证和姓名不匹配`
                            break
                        case 3102:
                            this.statusType = 1
                            // this.showStatus = true
                            this.statusInfo[1].reason = `当前账号已经认证其他证件`
                            break
                        case 3103:
                            this.statusType = 1
                            // this.showStatus = true
                            this.statusInfo[1].reason = `证件已经实名其他会员`
                            break
                        case 3105:
                            this.statusType = 1
                            // this.showStatus = true
                            this.statusInfo[1].reason = `证件或手机号被其他账号已认证`
                            break
                        case 7001:
                            this.statusType = 1
                            // this.showStatus = true
                            this.statusInfo[1].reason = `底层服务异常`
                            break
                        case 9000:
                            this.statusType = 1
                            // this.showStatus = true
                            this.statusInfo[1].reason = `请勿频繁请求`
                            break
                        case 500:
                            this.statusType = 1
                            // this.showStatus = true
                            this.statusInfo[1].reason = `系统错误`
                            break
                        case 1000:
                            this.statusType = 1
                            // this.showStatus = true
                            this.statusInfo[1].reason = `参数缺失`
                            break
                        case 7000:
                            this.statusType = 1
                            // this.showStatus = true
                            this.statusInfo[1].reason = res.msg
                            break
                        default:
                            this.statusType = 1
                            // this.showStatus = true
                            this.statusInfo[1].reason = `啊哦，认证失败啦`
                            break
                    }
                    this.showStatus = true
                } else if (+(res?.code) === 7000) {
                    this.statusType = 1
                    this.statusInfo[1].reason = res.msg
                    this.showStatus = true
                } else {
                    Toast(res.msg)
                }
                if (this.statusType === 0) {
                    setEvent({
                        action: 'attest_success_show',
                        label: '认证成功弹窗曝光',
                        value: ''
                    })
                } else if (this.statusType === 1) {
                    setEvent({
                        action: 'attest_fail_show',
                        label: '认证失败弹窗曝光',
                        value: {"channel":"学生认证","scene":"公共","reason": this.statusInfo[1].reason}
                    })
                }
            }).catch(err => {
                this.showStatus = false
                Toast('网络异常，请稍后再试')
            })
        },
        statusClick() {
            if (this.statusType === 0) {
                // toPage(`/forStudent`)
                setEvent({
                    action: 'attest_success_click',
                    label: '认证成功弹窗点击',
                    value: ''
                })
                // 认证成功，返回首页
                _tc_bridge_util.set_webview_back()
            } else {
                this.showStatus = false
                setEvent({
                    action: 'attest_fail_click',
                    label: '认证失败弹窗点击',
                    value: {"channel":"学生认证","scene":"公共","reason": this.statusInfo[1].reason}
                })
            }
            
        },
        okLeave() {
            setEvent({
                action: 'attest_detain_click',
                label: '学生认证挽留弹窗点击',
                value: {"channel":"学生认证","scene":"公共","site":"确认离开"}
            })
            _tc_bridge_util.set_webview_back()
        },
        cancelLeave() {
            this.showLeave = false
            setEvent({
                action: 'attest_detain_click',
                label: '学生认证挽留弹窗点击',
                value: {"channel":"学生认证","scene":"公共","site":"我再想想"}
            })
        },
        cancel() {
            setEvent({
                action: 'realname_detain_click',
                label: '实名弹窗点击',
                value: {"channel":"学生认证","scene":"公共","site":"取消"}
            })
            _tc_bridge_util.set_webview_back()
        },
        // 去实名
        toCertification() {
            setEvent({
                action: 'realname_detain_click',
                label: '实名弹窗点击',
                value: {"channel":"学生认证","scene":"公共","site":"去认证"}
            })
            this.confirmRealName = false
            if (compareVersion(this.deviceInfo.appVersionNumber,'10.4.3') > -1) {
                toPage('https://m.17u.cn/certification/tcRealName?wvc3=1&tcwvclogin')
            } else {
                window.location.href = window._tc_bridge_public.isTc? 'tctclient://member/realNameAuth' : ''
            }
        }
    },
}
</script>
<style lang="les" scoped src="./css/certification.less"></style>
<style lang="less">
body{
    // background-color: #F4F4F4;
}
</style>